import { Component, OnInit } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { CommonService } from "../../common/common.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"]
})
export class SidebarComponent implements OnInit {
  UserDetail: any;
  manageuser: boolean = false;
  club: boolean = false;
  event: boolean = false;
  notification: boolean = false;
  booking: boolean = false;
  about: boolean = false;
  contact: boolean = false;
  dashboard: boolean = false;
  state: boolean = false;
  indext :["main/course-management"]
  constructor(private commonService: CommonService,  public router :Router,) {
    router.events.subscribe((event) => {
      this.UserDetail = this.commonService.getUser();
      if (event instanceof NavigationStart) {
        if (event.url.startsWith('/main/course-management')) {
          if(this.UserDetail.role !== 'admin') {
            this.router.navigate(["/main/dashboard"]);
          }
          
          
          
        }
      }
    });
  }

  ngOnInit() {
    this.UserDetail = this.commonService.getUser();
  }
}
